import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import DocsSidebar from '../components/docs/DocsSidebar';
import DocsSearch from '../components/docs/DocsSearch';
import DocsBreadcrumb from '../components/docs/DocsBreadcrumb';
import DocsTableOfContents from '../components/docs/DocsTableOfContents';
import { MDXProvider } from '@mdx-js/react';
import MDXComponents from '../components/docs/MDXComponents';

const Docs = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  return (
    <div className="min-h-screen pt-20 pb-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile menu button */}
        <div className="lg:hidden mb-4">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="flex items-center gap-2"
          >
            {sidebarOpen ? (
              <>
                <X className="h-4 w-4" />
                <span>Close Menu</span>
              </>
            ) : (
              <>
                <Menu className="h-4 w-4" />
                <span>Open Menu</span>
              </>
            )}
          </Button>
        </div>

        <div className="flex gap-8">
          {/* Sidebar */}
          <aside 
            className={`
              w-64 flex-shrink-0 
              ${sidebarOpen ? 'block' : 'hidden'} 
              lg:block
              ${sidebarOpen && 'fixed lg:static inset-0 z-40 bg-background lg:bg-transparent pt-20 lg:pt-0 px-4 lg:px-0'}
            `}
          >
            <div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto">
              {sidebarOpen && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setSidebarOpen(false)}
                  className="lg:hidden absolute top-2 right-2"
                >
                  <X className="h-4 w-4" />
                </Button>
              )}
              <DocsSearch />
              <DocsSidebar />
            </div>
          </aside>

          {/* Overlay for mobile */}
          {sidebarOpen && (
            <div 
              className="fixed inset-0 bg-background/80 backdrop-blur-sm z-30 lg:hidden"
              onClick={() => setSidebarOpen(false)}
            />
          )}

          {/* Main Content */}
          <main className="flex-1 min-w-0 max-w-4xl">
            <DocsBreadcrumb />
            <MDXProvider components={MDXComponents}>
              <article className="prose prose-purple dark:prose-invert max-w-none">
                <Outlet />
              </article>
            </MDXProvider>
          </main>

          {/* Table of Contents */}
          <aside className="w-64 flex-shrink-0 hidden xl:block">
            <div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto">
              <DocsTableOfContents />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Docs;

